<template>
  <span>
    <v-avatar :size="avatarSize" class="user-avatar">
      <img v-if="url" :src="avatarImageUrl" />
      <v-icon v-else :size="iconSize" color="rgba(0,0,0,0.6)">mdi-account</v-icon>
    </v-avatar>
  </span>
</template>
<script>
export default {
  props: {
    userId: {
      type: [String, Number]
    },
    url: {
      type: String,
      default: null
    },
    avatarSize: {
      type: String,
      default: '50'
    },
    iconSize: {
      type: String,
      default: '40'
    },
    isCurrentUserAvatar: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    cacheKey: ''
  }),
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL;
    },
    avatarImageUrl() {
      if (this.url && this.url.includes('blob')) {
        return this.url;
      }
      return `${this.apiUrl}/maintainers/${this.userId}/image?token=${this.token}&imageCache=${this.cacheKey}`;
    },
    token() {
      return this.$store.getters.getToken;
    }
  },
  methods: {
    refreshAvatar(usersList) {
      this.cacheKey = JSON.parse(JSON.stringify(new Date().getTime()));
    },
    refreshCurrentUserAvatar() {
      this.cacheKey = JSON.parse(JSON.stringify(new Date().getTime()));
    }
  },
  created() {
    if (this.isCurrentUserAvatar) {
      this.$root.$on('refreshCurrentUserAvatar', this.refreshCurrentUserAvatar);
    } else {
      this.$root.$on(`refreshAvatar${this.userId}`, this.refreshAvatar);
    }
  }
};
</script>
<style lang="scss" scoped>
.user-avatar {
  border: 1px solid secondary;
  background-color: #dfdfdf;
}
</style>
